import { useSelector } from "react-redux";

import "./style.css"

function Gc() {
    const trad = useSelector(state => state.trad);
    const lang = useSelector(state => state.menu.lang);

    return (
        <div className='page_general_conditions_of_use'>
            <h2>{trad.title_general_conditions_of_use[lang]}</h2>
            
            <ul>
                {trad.data_general_conditions_of_use.map((data, idx) =>
                    <li key={idx}>
                        <h3>{idx + 1}. {data.title[lang]}</h3>
                        <p>{data.text[lang]}</p>
                    </li>
                )}
            </ul>
        </div>
    )
}

export default Gc;